var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseEyes = function SvgCloseEyes(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u51FA\\u5165\\u91D1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACH-\\u5165\\u91D1\\u586B\\u91D1\\u989D",
    transform: "translate(-600.000000, -541.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(600.000000, 541.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.649858, 4.520552)",
    stroke: "#62657A",
    strokeLinecap: "round",
    strokeWidth: 1.24444444
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C0.822242049,1.36039673 2.66914411,2.99796678 5.35014218,2.99796678 C8.03024712,2.99796678 9.87681169,1.3614876 10.6994623,0.00135966625",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.35014218,
    y1: 2.99796678,
    x2: 5.35014218,
    y2: 5.33130011,
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05391458,2.17088841 C1.41135323,2.84619441 1.71153341,3.32150305 1.95445514,3.59681434 C2.05985044,3.71626234 2.17602402,3.8224938 2.30297587,3.91550871",
    id: "Line-5-Copy",
    transform: "translate(1.678445, 3.043199) scale(-1, 1) rotate(-4.000000) translate(-1.678445, -3.043199) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44280347,2.17088841 C8.80024212,2.84619441 9.1004223,3.32150305 9.34334403,3.59681434 C9.44873933,3.71626234 9.56491291,3.8224938 9.69186476,3.91550871",
    id: "Line-5-Copy",
    transform: "translate(9.067334, 3.043199) rotate(-4.000000) translate(-9.067334, -3.043199) "
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseEyes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-eyes.6b857dbe.svg";